import React from 'react';
import { safeHref } from '../../utils/common/safe-url';
import { BrandBookingDto } from '../../api/payment/brand-deal.api';
import { hoursLabel } from '../../utils/brand-live';
import BrandLivePreviewFrame from './brand-live-preview-frame';
import { AdminOrdererLabel, ordererNoun } from '../brand-deal/orderer-badge';

// Nội dung thẻ duyệt đơn đặt quảng cáo ở trang admin: creator, phần bài, phần livestream kèm xem trước thẻ.

const fmtVnd = (n: number) => `${Number(n || 0).toLocaleString('vi-VN')}đ`;
const SHAPE: Record<string, string> = { Corner: 'Góc màn hình', BottomBar: 'Dải phía dưới', Vertical: 'Cạnh phải' };
const PLAN: Record<string, string> = { Monthly: 'Gói tháng', Hourly: 'Theo giờ' };

const AdminBookingReview: React.FC<{ booking: BrandBookingDto; ownerIdentityName?: string | null }> = ({ booking: b, ownerIdentityName }) => (
  <div className="mt-2 space-y-3 text-sm text-gray-700 dark:text-gray-200">
    <div>
      {ordererNoun(b.ordererKind)} <b><AdminOrdererLabel name={b.businessName} kind={b.ordererKind} ownerIdentityName={ownerIdentityName} /></b> đặt quảng cáo với creator <b>{b.creatorName}</b>. Tổng {fmtVnd(b.totalVnd)}.
    </div>
    <div className="text-xs">
      Link đích:{' '}
      <a href={safeHref(b.destinationUrl)} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
        {b.destinationUrl}
      </a>
    </div>
    {b.post && (
      <div className="rounded-md border border-gray-200 p-3 dark:border-gray-700">
        <div className="font-semibold">
          Phần đăng bài · {fmtVnd(b.post.priceVnd)} · giữ bài {b.post.holdDays} ngày
        </div>
        <div className="mt-1 whitespace-pre-wrap">{b.post.caption}</div>
        {(b.post.images.length > 0 || b.post.videos.length > 0) && (
          <div className="mt-2 flex flex-wrap gap-2">
            {b.post.images.map((img) => (
              <img key={img.id || img.url} src={img.url} alt="" className="size-20 rounded-md border border-gray-200 object-cover dark:border-gray-700" />
            ))}
            {b.post.videos.map((v) => (
              // eslint-disable-next-line jsx-a11y/media-has-caption
              <video key={v.id || v.url} src={v.url} controls className="h-20 rounded-md bg-black" />
            ))}
          </div>
        )}
      </div>
    )}
    {b.live && (
      <div className="rounded-md border border-gray-200 p-3 dark:border-gray-700">
        <div className="font-semibold">
          Phần livestream · {fmtVnd(b.live.priceVnd)} · {PLAN[b.live.plan] ?? b.live.plan} · {hoursLabel(b.live.purchasedSeconds)} · dùng trong{' '}
          {b.live.validDays} ngày
        </div>
        <div className="mt-1 text-xs">
          Vị trí: {b.live.slotName} ({SHAPE[b.live.slotShape] ?? b.live.slotShape})
        </div>
        <div className="mt-2 max-w-md">
          <BrandLivePreviewFrame
            ad={{ logoUrl: b.live.cardLogo.url, title: b.live.cardTitle, line: b.live.cardLine, goUrl: 'https://cab.vn' }}
            shape={b.live.slotShape}
          />
        </div>
      </div>
    )}
  </div>
);

export default AdminBookingReview;
